import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

const ONCELIK_RENK: Record<string, string> = { 'dusuk': '#94a3b8', 'normal': '#1890ff', 'yuksek': '#ff9500', 'acil': '#ff4d4f' };
const DURUM_RENK: Record<string, string> = { 'bekliyor': '#94a3b8', 'devam-ediyor': '#1890ff', 'tamamlandi': '#52c41a', 'iptal': '#ff4d4f' };

@Component({
  selector: 'projeler-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ui text-center fluid pb-2">
      <div class="ui primary label mini"> Proje Tanımı </div>
    </div>
    <div class="sk" [style.--sk-accent]="oncelikRenk()">
      <div class="sk-icerik">
        <div style="text-align: center;">
          <img src="./simgeler/3d-printer.png"  style="max-width: 96px;max-height: 96px;border-radius: 50%;border: 3px solid #9e9ef9;" />
        </div>
        <div class="sk-baslik text-center">{{ deger('projeAdi') || 'Isimsiz Proje' }}</div>
        @if (deger('aciklama')) { <div class="sk-alt">{{ deger('aciklama') }}</div> }
        @if (deger('musteri')) { <div class="sk-alt">{{ deger('musteri') }}</div> }
        <div style="display:flex;align-items:center;gap:4px;margin-top:2px">
          @if (deger('durum')) { <span class="sk-chip" [style.border-color]="durumRenk()" [style.color]="durumRenk()">{{ deger('durum') }}</span> }
          @if (deger('oncelik')) { <span class="sk-chip" [style.border-color]="oncelikRenk()" [style.color]="oncelikRenk()">{{ deger('oncelik') }}</span> }
        </div>
        @if (ilerleme() > 0) {
          <div class="sk-bar"><div class="sk-bar-dolgu" [style.width.%]="ilerleme()" [style.background]="oncelikRenk()"></div></div>
        }
      </div>
      <div class="sk-sag">
        @if (deger('baslangicTarihi') || deger('bitisTarihi')) {
          <span class="sk-alt" style="font-size:10px">{{ deger('baslangicTarihi') | date:'dd.MM' }} - {{ deger('bitisTarihi') | date:'dd.MM' }}</span>
        }
      </div>
    </div>
  `,
})
export class ProjelerKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  oncelikRenk = computed(() => ONCELIK_RENK[this.deger('oncelik')] || '#1890ff');
  durumRenk = computed(() => DURUM_RENK[this.deger('durum')] || '#94a3b8');
  ilerleme = computed(() => +(this.deger('ilerleme') || this.p()?._hesap?.ilerleme || 0));
}
